import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import FeaturedWiresContext, { reducer, defaultState } from './context';
import { SectionDetailLabel } from '../styles';
import WireView from './wire-view';
import Selector from './selector';
import {
  useGetFeaturedWires, useGetFeatureableWires,
} from '../../../../../services/wires/featured-wires-service';

const TRIGGERS = ['add', 'remove'];
export default function Settings({ profileId, onUpdate }) {
  const [state, dispatch] = React.useReducer(reducer, defaultState);
  const [, get] = useGetFeaturedWires();
  const [, getCandidates] = useGetFeatureableWires();

  useChangeAwareEffect(({ isMount }) => {
    if (!isMount) {
      return;
    }
    getCandidates().then(({ data }) => {
      const wires = _.get(data, 'wires');
      _.get(wires, 'length') !== undefined && dispatch({ type: 'setInitial', payload: wires });
    });
    get().then(({ data }) => {
      const wires = _.get(data, 'wires');
      _.get(wires, 'length') !== undefined && dispatch({ type: 'setWires', payload: wires });
    });
  }, {});

  const { featured, trigger } = state;

  useChangeAwareEffect(({ did }) => {
    if (did.featured.change && did.trigger.change && TRIGGERS.indexOf(trigger) >= 0) {
      onUpdate({ featuredWires: featured });
    }
  }, { featured, trigger });

  return (
    <FeaturedWiresContext.Provider value={{ state, dispatch }}>
      {_.times(3).map(i => (
        <React.Fragment key={`sect-${i + 1}`}>
          <SectionDetailLabel>{`featured wire ${i + 1}`}</SectionDetailLabel>
          {
            (featured[i] && !featured[i].toChange)
              ? <WireView {...{ wire: featured[i], profileId }} />
              : <Selector prevId={_.get(featured[i], 'id', null)} />
          }
        </React.Fragment>
      ))}
    </FeaturedWiresContext.Provider>
  );
}

Settings.propTypes = {
  profileId: PropTypes.number.isRequired,
  onUpdate: PropTypes.func,
};

Settings.defaultProps = { onUpdate: () => null };
